export default __webpack_public_path__ + "images/id-e2afd171e6a62816237b8c39bdb26ccc.svg";